import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Camera, ArrowRight } from "lucide-react";

export default function Galeri() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [searchParams] = useSearchParams();
  useEffect(() => {
    api.get("/gallery").then((r) => {
      setItems(r.data);
      const fotoId = searchParams.get("foto");
      if (fotoId) {
        const found = r.data.find((g) => g.id === fotoId);
        if (found) setSelected(found);
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div data-testid="galeri-page">
      <PageHeader title="Galeri Kegiatan" subtitle="Foto dan dokumentasi kegiatan penanggulangan bencana BPBD Kayong Utara" />
      <section className="max-w-7xl mx-auto px-4 py-16">
        {items.length === 0 ? (
          <div className="border-2 border-dashed border-slate-200 rounded-xl p-16 text-center text-slate-400" data-testid="galeri-empty">
            <Camera className="mx-auto mb-3" size={32} />
            Belum ada dokumentasi kegiatan yang diunggah.
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((g) => (
              <button
                key={g.id}
                onClick={() => setSelected(g)}
                className="group hover-lift text-left border border-slate-200 rounded-xl overflow-hidden bg-white"
                data-testid={`galeri-item-${g.id}`}
              >
                <div className="overflow-hidden">
                  <img src={g.image_url} alt={g.title} className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300" />
                </div>
                <div className="p-4">
                  <p className="font-heading font-semibold text-sm text-slate-900 line-clamp-1">{g.title}</p>
                  {g.description && <p className="text-xs text-slate-500 mt-1 line-clamp-2">{g.description}</p>}
                  <span className="inline-flex items-center gap-1 text-xs font-bold text-orange-600 mt-2 group-hover:gap-2 transition-all">
                    Selengkapnya <ArrowRight size={11} />
                  </span>
                </div>
              </button>
            ))}
          </div>
        )}
      </section>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="max-w-2xl max-h-[88vh] overflow-y-auto" data-testid="galeri-detail-dialog">
          {selected && (
            <>
              <DialogHeader>
                <DialogTitle className="font-heading text-xl">{selected.title}</DialogTitle>
              </DialogHeader>
              <img src={selected.image_url} alt={selected.title} className="w-full rounded-lg border border-slate-200" />
              {selected.description && <p className="text-sm text-slate-600 whitespace-pre-line leading-relaxed">{selected.description}</p>}
              <p className="font-mono text-xs text-slate-400">
                {new Date(selected.created_at).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" })}
              </p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
